<template>
  <div>
    <v-app>
      <v-main>
        <v-container class="container-1" fluid fill-height>
          <v-row justify="center" align="center" class="login-row">
            <v-col cols="10" sm="6" md="4">
              <v-card class="elevation-12">
                <!-- 登录界面标题内容  -->
                <v-card-title class="mb-2" dark flat
                  style="background-color:#83e2e0;justify-content:center; align-self:center; text-align:center;">
                  <v-card-title style="font-weight:550; color:rgba(0,0,0,0.7);letter-spacing: 10px;">登录界面</v-card-title>
                </v-card-title>
                <!--  登录功能验证表单  -->
                <v-card-text class=''>
                  <v-form ref='login' v-model="valid">
                    <v-text-field label="用户名/邮箱" name="username" prepend-icon="mdi-account" type="text"
                      v-model="username" :rules="requiredRules">
                    </v-text-field>
                    <v-text-field label="密码" name="password" prepend-icon="mdi-lock" type="password" v-model="password"
                   :rules="[rules.required, rules.min]">
                    </v-text-field>
                    <!-- <v-checkbox label="记住密码(功能取消)" name="remember" v-model="remember"></v-checkbox>   -->
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn width='100%' color="primary" :disabled="!valid" @click="loginUser">登录</v-btn>
                </v-card-actions>
                <!-- <v-card-text>  
                  <p>  
                    没有帐户/忘记密码？  
                  </p>  
                </v-card-text>   -->
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <!-- 添加登录成功或失败的对话框 -->
        <v-dialog v-model="loginDialog" max-width="220">
          <v-card justify="center" align="center">
            <v-card-title style="justify-content: center;" class="headline">{{ dialogTitle }}</v-card-title>
            <v-card-text>{{ dialogMessage }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn width='100%' text @click="loginDialog = false">确定</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-main>
    </v-app>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: '',
      password: '',
      valid: false,
      remember: false,
      requiredRules: [v => !!v || '该字段是必填项',],
      rules: {
        required: value => !!value || '必填',
        min: value => value?.length >= 6 || '至少6位',
      },
      loginDialog: false,
      dialogTitle: '',
      dialogMessage: '',
      showPassword: false,  


      // 后增对象字段
      name: '',
      namePassword: '',
      dialog: false,
      dialogTitle: '',
      dialogMessage: '',
      isLoading: false,
    }
  },
  methods: {

    // 前端固定密码进行验证登录系统
    // login() {
    //   this.$refs.login.validate()

    //   if (this.username === this.name && this.password === this.namePassword) {
    //     this.dialogTitle = '登录成功!'
    //     this.dialogMessage = '欢迎回来，管理员！'
    //     this.loginDialog = true

    //     setTimeout(() => {

    //       this.loginDialog = false
    //       this.$router.push('/home')
    //     }, 2000)
    //   } else {
    //     this.dialogTitle = '登录失败!'
    //     this.dialogMessage = '用户名或密码错误，请重新输入。'
    //     this.loginDialog = true
    //   }
    // },

    toggleShowPassword() {  

this.showPassword = !this.showPassword;  

},  

    // 进行前后端交互访问数据库验证
    async loginUser() {
      try {
        if (!this.$refs.login.validate()) return;

        const response = await this.$axios.post(`http://192.168.3.3:18081/user/products?username=${this.username}`, {
          username: this.username,
        });
        const data = await response.data;
        // console.log(response);
        if (data.code === 200) {
          this.name = data.data[0].username;
          this.namePassword = data.data[0].password;

          // console.log(this.name);  
          // console.log(this.namePassword); 

          if (this.username === this.name && this.password === this.namePassword) {
            this.dialogTitle = '登录成功!';
            this.dialogMessage = '欢迎回来，管理员！';
            this.loginDialog = true;

            setTimeout(() => {
              this.loginDialog = false;
              this.$router.push('/home');
            }, 2000)
          } else {
            this.dialogTitle = '登录失败!';
            this.dialogMessage = '用户名或密码错误，请重新输入。';
            this.loginDialog = true;
            this.resetForm();
          }
        } else {
          alert(data.message);
        }

      } catch (error) {

        console.error('登录失败:', error);
        this.dialogTitle = '登录失败!';
        this.dialogMessage = '网络错误，请重试。';
        this.loginDialog = true;
      } finally {
        this.loading = false;
      }
    },
    // async resetForm() {
    //   this.username ='',
    //   this.password= ''
    // }
  }
}  
</script>

<style>
.login-row {
  height: 100vh;
}

.container-1 {
  /* width: 100%;
  height: 100%; */
  background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
  background-size: 400% 400%;
  animation: gradientBG 15s ease infinite;
}
</style>